import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VueTagsInput, { AddTagEvent, DeleteTagEvent, Tag } from '@sipec/vue3-tags-input';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import { PropType, ref, watch, computed } from 'vue';
import { useVModel } from '@vueuse/core';
import Toast from '@shared/services/toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagsInput',
  props: {
  elementId: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  disabled: {
    type: Boolean,
  },
  beforeAddingTag: {
    type: Function as PropType<() => boolean>,
  },
  validation: {
    type: Function as PropType<(input: string) => boolean>,
  },
  validationErrorMessage: {
    type: String,
    default: '',
  },
  addTagsOnSpace: {
    type: Boolean,
    default: false,
  },
  limit: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default: [],
  },
},
  emits: ["update:modelValue", "text-updated", "tags-updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const model = useVModel(props, 'modelValue', emit);

const inputValue = ref<string>('');
const displayTags = ref<{ text: string; tiClasses?: string[] }[]>([]);

const addOnKey = computed(() => (props.addTagsOnSpace ? [13, ',', ' '] : [13, ',']));

// Sync with modelValue on mount and updates
watch(
  model,
  (values: string[], oldValues: string[]) => {
    if (!values || arraysEqual(values, oldValues)) return;

    displayTags.value = values.map((tagText: string) => ({ text: tagText }));
  },
  { immediate: true },
);

function onBeforeAddingTag(evt: AddTagEvent) {
  const rawValue = evt.tag.text;

  evt.tag.text = HtmlFormatter.escapeHtmlCharacters(rawValue);

  // Perform validation here to control whether the tag is added
  if (props.validation && !props.validation(evt.tag.text)) {
    if (props.validationErrorMessage) {
      Toast.showError(props.validationErrorMessage); // Use custom error message
    }
    return; // Prevent adding the tag
  }

  if (!props.beforeAddingTag || props.beforeAddingTag()) {
    evt.addTag();
  }
}

function onBeforeRemovingTag(evt: DeleteTagEvent) {
  evt.deleteTag();
}

function onTagsUpdated(newTags: Tag[]) {
  model.value = newTags.map((tag: Tag) => tag.text);
  emit('tags-updated');
}

function onInput(newValue: string) {
  emit('text-updated', newValue);
}

function arraysEqual(a: any[], b: any[]) {
  if (a === b) return true;
  if (!a || !b || a.length !== b.length) return false;
  return a.every((item, i) => item === b[i]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueTagsInput), {
    modelValue: inputValue.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      onInput
    ],
    tags: displayTags.value,
    disabled: __props.disabled,
    placeholder: __props.placeholder,
    "max-tags": __props.limit,
    "add-on-key": addOnKey.value,
    "add-on-blur": true,
    onBeforeAddingTag: onBeforeAddingTag,
    onBeforeDeletingTag: onBeforeRemovingTag,
    onTagsChanged: onTagsUpdated
  }, null, 8, ["modelValue", "tags", "disabled", "placeholder", "max-tags", "add-on-key"]))
}
}

})